import axios from "axios";
import { ENDPOINT } from "../ENDPOINT";

export const PermissionService = {
    
  getAllPermission: async () => {
    try {
      const response = await axios.get(ENDPOINT.Permission);
      return response.data;
    } catch (error) {
      console.error("Error fetching Permission:", error.message);
      throw error;
    }
  },

   getLastPermission: async () => {
    try {
      const response = await axios.get(`${ENDPOINT.Permission}/last`);
      return response.data;
    } catch (error) {
      console.error("Error fetching Permission:", error.message);
      throw error;
    }
  },

  getAllPermissionById: async (id) => {
    try {
      const response = await axios.get(`${ENDPOINT.Permission}/permissions/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching Permission:", error.message);
      throw error;
    }
  },

  getAllActivePermissionById: async (id) => {
    try {
      const response = await axios.get(`${ENDPOINT.activePermission}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching Permission:", error.message);
      throw error;
    }
  },

   getPermissionDetailsById: async (id) => {
    try {
      const response = await axios.get(`${ENDPOINT.Permission}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching Permission:", error.message);
      throw error;
    }
  },

  createPermission: async (data) => {
    try {
      const response = await axios.post(ENDPOINT.Permission, data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching Permission:", error.message);
      throw error;
    }
  },

  updatePermission: async (data, id) => {
    try {
      const response = await axios.put(`${ENDPOINT.Permission}/${id}`, data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching Permission:", error.message);
      throw error;
    }
  },

  deletePermission: async ( id) => {
    try {
      const response = await axios.delete(`${ENDPOINT.Permission}/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching quotation:", error.message);
      throw error;
    }
  },

  createCustomer: async (data) => {
    try {
      const response = await axios.post(ENDPOINT.customer, data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching Permission:", error.message);
      throw error;
    }
  },

  updateCustomer: async (data, id) => {
    try {
      const response = await axios.put(`${ENDPOINT.customer}/${id}`, data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        });
      return response.data;
    } catch (error) {
      console.error("Error fetching Permission:", error.message);
      throw error;
    }
  },
}